import { render } from "./Milestone.vue?vue&type=template&id=0b660ac3&scoped=true&ts=true"
import script from "./Milestone.vue?vue&type=script&lang=tsx"
export * from "./Milestone.vue?vue&type=script&lang=tsx"

import "./Milestone.vue?vue&type=style&index=0&id=0b660ac3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Profectus/Profectus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b660ac3"]])

export default __exports__